// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c98d","col":"styles_col__1v0n5"};